import Vue from "vue";

import Vuex from "vuex";
Vue.use(Vuex);

import VueResource from "vue-resource";
Vue.use(VueResource);

Vue.http.options.root = "http://localhost:4000/";

export default {
  submitForm1({ commit, state, rootState }, data) {
    axios
      .post(
        "https://strapi-kencove.p.kencove.com/api/contact-form-results",
        {"data": data},
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        console.log(response);
        return;
      })
      .catch(error => {
        console.log(error.response);
      });
  },
  submitForm2({ commit, state, rootState }, data) {
    axios
      .post(
        "https://api-kencove.azurewebsites.net/api2/kencove/vue/catalog",
        data,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        console.log(response);
        return;
      })
      .catch(error => {
        console.log(error.response);
      });
  },
  submitForm3({ commit, state, rootState }, data) {
    axios
      .post(
        "https://api-kencove.azurewebsites.net/api2/kencove/vue/tax",
        data,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        console.log(response);
        return;
      })
      .catch(error => {
        console.log(error.response);
      });
  },
  submitForm4({ commit, state, rootState }, data) {
    axios
      .post(
        "https://api-kencove.azurewebsites.net/api2/vue/cs_form/customer_interaction",
        data,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        console.log(response);
        return;
      })
      .catch(error => {
        console.log(error.response);
      });
  }
};



// WEBPACK FOOTER //
// ./src/store/actions.js